var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"shake","mode":"out-in"}},[(_vm.visible)?_c('img',{staticClass:"rotate",attrs:{"src":require("@/assets/images/msg.png"),"width":"35","height":"35"}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }